import React, {Component} from "react";
import PropTypes from "prop-types";
import moment from "moment";
import timeHuman from "../../../../../helpers/time/timeHuman";
import {Link} from "react-router-dom";
import ReactCountryFlag from 'react-country-flag';
import ReactTooltip from "react-tooltip";
import classNames from "classnames";
import styles from "./UserItem.scss";
import {_countTotalLogin} from "../../../../../services/apis/AdminUserServices"

class UserItem extends Component {
    state = {
        totalLogin: 0
    }

    componentDidMount() {
        this._fetchTotalLogin()
    }

    _fetchTotalLogin = async () => {
        const {_id} = this.props.data

        const {success, data} = await _countTotalLogin(_id)

        if (success) {
            this.setState({
                totalLogin: data
            })
        }
    }

    render() {
        const {data, order} = this.props;

        const {profile, membership, email, IP, note, location, status} = data;
        const {name} = profile;
        const id = data._id;
        const plan = membership ? membership.plan : false;
        const planText = plan ? plan.title : 'None';
        const finishText = membership ? timeHuman(membership.finish, 'DD-MM-YYYY') : '';

        const now = moment();
        const finishMoment = membership ? moment(membership['finish']) : moment();
        const isExpired = !membership || finishMoment.isBefore(now);

        const {totalLogin} = this.state

        return (
            <tr className={classNames("User", styles[status])} id={`User-${id}`} key={id}>
                <td className="order">{order}</td>
                <td className="name">
                    <Link to={`/a/users/${id}`}>{name}</Link>
                    <Link className={styles.switch} to={`/a/switch-user/${id}`}>
                        <span className="Switch">
                            <i className="fas fa-exchange-alt"/>
                        </span>
                    </Link>
                </td>
                <td className="email">({totalLogin}) {email}</td>
                <td className="membership">
                    {
                        isExpired ? 'None' : <span>{planText} ({finishText})</span>
                    }
                </td>

                <td>{note}</td>

                <td className="IP">
                    {
                        (location && Object.keys(location).length > 1 && location.country) &&
                        <span data-tip data-for={`${id}-location`} title={`${location.city}, ${location.country}`}
                              className={styles.location}>
                            <ReactCountryFlag code={location.country} svg/>

                            <ReactTooltip id={`${id}-location`} place="left" type="success" effect='solid'>
                                <span>{`${location.city}, ${location.country}`}</span>
                            </ReactTooltip>
                        </span>
                    }

                    <a href={`https://ipinfo.io/${IP}`} target="_blank">{IP}</a>
                </td>
            </tr>
        );
    }
}

UserItem.propTypes = {
    order: PropTypes.number,
    data: PropTypes.object,
};

export default UserItem;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/users/UserItem/UserItem.js